import React from 'react'
import './TopArticulos.css'
import HorizontalBarChart from './HorizontalBarChart'
import { Dashboard } from '../../ArticulosVendidos.type'

const TopArticulos = ({articulos}: {articulos: Dashboard["top_5_articulos"]}) => {
    return (
        <div className='articulos-vendidos__card'>
            <span className='top__articulos__title'>Top 5 de productos más vendidos</span>
            <div>
                <HorizontalBarChart
                    data={articulos?.map(a => ({
                        label: a[0],
                        value: Number(a[1] || 0),
                    })) || []}
                    barHeight={8}
                    maxWidth={112}
                    labelWidth={87}
                />
            </div>
        </div>
    )
}

export default TopArticulos
